const guideGen32 = [
  "Alabastia – Starter-Pokémon erhalten",
  "Route 1",
  "Vertania City – Pokémon-Markt & Karte",
  "Route 22 – Rivalenkampf (optional)",
  "Route 2 & Vertania-Wald – Pokémon fangen",
  "Marmoria City – 1. Arena (Gestein – Rocko)",
  "Route 3 & Mondberg durchqueren",
  "Azuria City nach oben verlassen --> Rivalenkampf",
  "Azuria City – 2. Arena (Wasser – Misty)",
  "Route 24 & 25 – Nugget-Brücke & Bill treffen",
  "Route 5 & 6 – Durch das Haus nach Süden",
  "S.S. Anne betreten & Rivalenkampf und Zerschneider holen",
  "Orania City – 3. Arena (Elektro – Major Bob)",
  "Route 9 & Felstunnel durchqueren",
  "Lavandia",
  "Route 8 & 7 – Tunnelpassage nach Prismania City",
  "Prismania City – 4. Arena (Pflanze – Erika)",
  "In Prismania Villa Tee für Wächter erhalten (Optional)",
  "Team Rocket im Untergrundlager besiegen",
  "Silph Scope holen & zurück nach Lavandia",
  "Pokémon-Turm abschließen & Geist identifizieren",
  "Route 12 & 13 – Angler & Entoron-Route",
  "Fuchsania City – 5. Arena (Gift – Koga)",
  "Safari-Zone & VM Surfer finden & Stärke finden",
  "Kraftwerk --> Zapdos (Optional)",
  "Silph Co Gebäude in Saffronia City",
  "Etage 8 unten rechts tp zu Etage 4 ",
  "Türöffner --> Etage 2 TP zu Kampf gegen Rivalen",
  "Kampf gegen Team Rocket Boss --> Meisterball erhalten",
  "6.Arena Saffronia City",
  "Route 20 & 21 – Seeschauminseln --> Arktos (optional)",
  "Zinnoberinsel – Pokémon-Haus & Labor",
  "7. Arena (Feuer – Pyro) betreten",
  "Eiland Eins --> Gluttherme für Zertrümmer",
  "Glutberg --> Lavados (Optional)",
  "Eiland Drei Biker besiegen -->Beerenforst Mädchen befreien",
  "Auf Eiland Eins Mit Bill Sprechen",
  "8. Arena (Wasser – Giovanni)",
  "Kampf gegen Rivalen – Siegesstraße",
  "Pokémon Liga – Top 4 & Rivale als Champ",
];

export default guideGen32;
